import type { LayoutProps } from "@/features/companyDetail/types"
import type { PagesRouterPage } from "@/types"
import type { PropsWithChildren } from "react"

import { Layout } from "@/features/companyDetail/components/Layout"
import { ArticleDetails } from "@/modules/companies/client/components/ArticleDetails/ArticleDetails"

export const PageContent: PagesRouterPage<PropsWithChildren<LayoutProps>> = props => {
  return (
    <Layout {...props}>
      <ArticleDetails />
    </Layout>
  )
}
